<template>
  <nav class="topbar" :style="{ width: width }">
    <transition name="fade" :duration="{ enter: 250, leave: 0 }">
      <div class="topbar__navigation">
        <router-link
          v-if="backButtonVisible"
          class="topbar__back"
          :to="currentBackLink"
        >
          <div class="topbar__back-img">
            <img src="@/assets/back.png" alt="" />
          </div>
          <span class="topbar__back-text">
            {{ $t('topbar.back') }}
          </span>
        </router-link>
        <a v-else-if="isFavourite" class="topbar__back" @click="$router.go(-1)">
          <div class="topbar__back-img">
            <img src="@/assets/back.png" alt="" />
          </div>
          <span class="topbar__back-text">
            {{ $t('topbar.back') }}
          </span>
        </a>
        <!-- <a
          v-else-if="isBuilding"
          class="topbar__back"
          href="https://www.miasteczkojutrzenki.pl/wyszukiwarka"
        >
          <div class="topbar__back-img">
            <img src="@/assets/back.png" alt="" />
          </div>
          <span class="topbar__back-text">
            Powrót do listy mieszkań
          </span>
        </a> -->
      </div>
    </transition>

    <div class="topbar__links">
      <span v-if="isCountry" class="topbar__text">{{
        $t('topbar.chooseInvestment')
      }}</span>
      <span v-else-if="isBuildings" class="topbar__text">{{
        $t('topbar.chooseBuilding')
      }}</span>
      <span v-else-if="isBuilding" class="topbar__text">{{
        $t('topbar.chooseFloor')
      }}</span>
      <span
        v-else-if="isFloor || (isList && $route.params.building)"
        class="topbar__text"
        >{{ $t('topbar.chooseFlat') }}</span
      >
      <span v-else-if="isFlat && flat" class="topbar__text"
        >{{ $t('flat') }} {{ $route.params.flat }}</span
      >
      <span v-else-if="isFavourite" class="topbar__text">{{
        $t('topbar.favourites')
      }}</span>
    </div>

    <div class="topbar__right">
      <div class="topbar__position">
        <div class="topbar__geo">
          <img src="@/assets/pin.png" alt="" />
        </div>
        <p class="topbar__text">{{ $t('topbar.kolobrzeg') }}</p>
      </div>

      <div class="topbar__buttons">
        <router-link
          to="/favourites"
          class="topbar__button wishlist"
          :title="$t('topbar.favourites')"
        >
          <span class="wishlist__badge">{{ favourites }}</span>
          <img src="@/assets/heart2.svg" alt />
        </router-link>
        <button
          v-if="!isFlat && !isFavourite"
          class="topbar__button"
          @click="toggleSidebar"
          :title="$t('topbar.filtering')"
        >
          <img src="@/assets/filters.png" alt />
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import TempScrollBox from '@/plugins/scrollbox.js';

export default {
  name: 'topbar',
  computed: {
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
      currentInvestment: state => state.browser.currentInvestment,
    }),

    favourites() {
      return this.$store.getters.GET_FAVOURITES.length;
    },
    investmentName() {
      if (this.currentInvestment) {
        return this.currentInvestment.investmentName;
      }
      return '';
    },
    backButtonVisible() {
      let visibleOn = ['list', 'floor', 'flat'];
      // if (this.currentInvestment && this.currentInvestment.multiBuilding) {
      //   visibleOn.push("building");
      // }
      return visibleOn.includes(this.$route.name.toLowerCase());
    },
    isCountry() {
      return this.$route.name == 'country';
    },
    isBuildings() {
      return this.$route.name == 'investment';
    },
    isBuilding() {
      return this.$route.name == 'building';
    },
    isFloor() {
      return this.$route.name == 'floor';
    },
    isFlat() {
      return this.$route.name == 'flat';
    },
    isList() {
      return this.$route.name == 'list' || this.$route.name == 'listfloor';
    },
    isFavourite() {
      return this.$route.name == 'favourites';
    },
    flat() {
      return this.getFlat(this.$route.params.flat);
    },
    width() {
      let fixedOn = ['investment', 'building'];
      return fixedOn.includes(this.$route.name)
        ? `calc(100% - ${this.getScrollWidth()}px)`
        : '100%';
    },
    currentBackLink() {
      if (this.isFlat && this.flat) {
        return `/${this.currentInvestment.url}/building/${
          this.flat[this.flatProperties['building']]
        }/floor/${this.flat[this.flatProperties['floor']]}`;
      }

      if (this.isFloor) {
        return `/${this.currentInvestment.url}/building/${this.$route.params.building}`;
      }

      if (this.isBuilding) {
        return `/${this.currentInvestment.url}`;
      }

      if (this.currentInvestment) {
        return `/${this.currentInvestment.url}`;
      }

      return '/';
    },
  },
  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_SIDEBAR',
    }),
    getFlat(id) {
      let flat = this.$store.getters.GET_FLATS_BY_PROPERTY(
        this.flatProperties['id'],
        id
      );
      if (flat) return flat[0];
      return false;
    },
    getScrollWidth() {
      let scrollbox = new TempScrollBox();
      return scrollbox.width;
    },
  },
};
</script>

<style lang="scss" scoped>
.topbar {
  width: 100%;
  height: $topbarHeight;
  min-height: $topbarHeight;

  position: relative;
  z-index: 40;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background: #fff;
  color: #000;
  box-shadow: 0 20px 50px rgba(#000, 0.1);
  @media screen and (max-width: $sm) {
    width: 100% !important;
  }
  &.full {
    position: fixed;
    top: 0;
    width: 100% !important;
    // background: rgba(#ccc, 0.8);
  }
}
.topbar__links {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-weight: 600;
  font-size: 20px;

  @media screen and (max-width: $xs) {
    font-size: 12px;
    display: flex;
    align-items: center;
  }
  @media screen and (max-width: $xxs) {
    font-size: 10px;
  }
}
.topbar__link {
  color: #000;
}

.topbar__space {
  margin: 0 4px;
}

.topbar__back {
  padding-left: 14px;
  padding-right: 28px;

  display: flex;
  align-items: center;
  height: 100%;

  border: none;
  color: #000;
  background: rgba(#fff, 0.55);
  border-bottom-right-radius: 40px;
  text-decoration: none;

  cursor: pointer;

  @media screen and (max-width: $sm) {
    position: static;
    transform: none;
  }
}

.topbar__back-text {
  font-weight: 400;
  font-size: 14px;
  @media screen and (max-width: $sm) {
    display: none;
  }
}

.topbar__back-img {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  background: $lightGray;
  margin-right: 12px;

  transition: 150ms background ease;

  img {
    display: block;
    height: 40%;
    width: auto;
  }
  &:hover {
    background: $primaryColor;
  }
}

.topbar__buttons {
  height: 100%;

  display: flex;
  align-items: center;

  background: $primaryColor;
  padding: 0 16px;

  @media screen and (max-width: $sm) {
    position: static;
    transform: none;
  }

  @media screen and (max-width: $xs) {
    padding: 0 8px;
  }
}

.topbar__button {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 36px;
  height: 34px;

  margin: {
    right: 12px;
  }

  background: none;
  border: none;
  text-decoration: none;

  cursor: pointer;

  img {
    display: block;
    max-width: 60%;
    max-height: 63%;
  }
  @media screen and (max-width: $xs) {
    width: 28px;
    height: 28px;
    margin: {
      right: 4px;
    }
  }
}

.topbar__subtext {
  font-size: 14px;
  font-weight: 500;
  margin: {
    right: 6px;
  }
  @media screen and (max-width: $lg) {
    display: none;
  }
}

.topbar__user {
  display: flex;
  justify-items: center;
  align-items: center;
  background: white;
  padding: 10px 40px 10px 20px;
  border-radius: 0 0 50px 0;
  height: 100%;
}

.topbar__navigation {
  display: flex;
  justify-items: center;
  align-items: center;
  background: transparent;
  height: 100%;
}

.topbar__avatar {
  height: $topbarHeight / 1.6;
  width: $topbarHeight / 1.6;

  background: #e6e6e6;
  border-radius: 50%;
  margin-right: 10px;
}

.wishlist {
  position: relative;
  width: 50px;
  height: 50px;
  padding: 5px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.2);
  &__badge {
    display: flex;
    position: absolute;
    justify-content: center;
    align-items: center;
    top: -5px;
    right: -5px;
    min-width: 20px;
    min-height: 20px;
    border-radius: 50%;
    color: white;
    font-weight: 700;
    background: $darkGray;
    font-size: 11px;
  }
}

.topbar__username {
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  color: inherit;
  margin-left: 10px;
  @media screen and (max-width: $xs) {
    display: none;
  }
}

.topbar__right {
  display: flex;
  width: $sidebarWidth;
  height: 100%;
  @media screen and (max-width: $lg) {
    justify-content: flex-end;
  }
}

.topbar__position {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: {
    top: 12px;
    bottom: 12px;
    right: 2rem;
    left: 1.5rem;
  }
  color: #ffffff;
  font-weight: 600;
  font-size: 22px;
  background: $darkGray;
  @media screen and (max-width: $lg) {
    display: none;
  }
}

.topbar__geo {
  margin-right: 20px;
  height: 24px;
  img {
    display: block;
    height: 100%;
    object-fit: contain;
  }
}
</style>
